import styled from "@emotion/styled/macro";
import isPropValid from "@emotion/is-prop-valid";

const TextInput = styled<"input", { isValid?: boolean; center?: boolean }>(
  `input`,
  {
    shouldForwardProp: isPropValid
  }
)`
  padding: 7px 16px;
  border-radius: 10px;
  background: ${({ isValid = true }) => (isValid ? "#ccd0da" : "#cb3d3d")};
  color: ${({ isValid = true }) => (isValid ? "inherit" : "#fff")};
  border: 1px solid transparent;
  width: 100%;
  text-align: ${({ center = false }) => (center ? "center" : "left")};

  &:focus {
    border-color: inherit;
    outline: none;
  }
`;

export default TextInput;
